module.exports = __webpack_public_path__ + "media/images/gallery-7-a6db5cf9.jpg";